// 业务类型
export const bizTypeEnumMap = {
  NORMAL: '普通订单',
  GROUP: '拼团',
  CYCLE_BUY: '周期购',
  REGULAR_ORDERING: '常规订货',
  PACKAGING_MATERIALS: '包材',
  MATERIAL_PROPS: '物料道具',
  RETAIL: '零售',
  POLICY_PROMOTION: '政策促销',
  SPECIAL_POLICIES: '特殊政策',
  EXHIBITION: '订货会',
  CENTRALIZED_ACQUIRING: '集中收单',
  ONLINE_DROPSHIPPING: '线上代发',
  OFFLINE_DROPSHIPPING: '线下代发',
  ADVANCED_CUSTOMIZATION: '高级定制',
  PICK_COLOR_AND_CUSTOMIZE: '挑色定制',
  GIFT: '礼品',
  SAMPLE_LOAN: '样品借用',
  SAMPLE_RETURN: '样品归还',
  PAPER_DIRECT_DELIVERY: '纸品直发',
  RETURN_EXCHANGE: '换货'
};

// 代发方式
export const ariesIssuingMethodEnumMap = {
  NOMAL: '常规',
  ONE: '一件代发',
  ONLINE:'线上代发',
  OFFLINE: '线下代发',
  MASTER_EXPRESS: '总部直发快递',
  MASTER_CONSIGNED: '总部直发托运',
  WAREHOUSE_PROXY: '仓库代发',
  TRANSFER: '转配',
  OMS: '电商代发'

};

// 仓库类型
export const warehouseKindEnumMap = {
  SALE: '成品仓',
  REVERSE: '售后仓',
  CONSIGNMENT: '寄售仓',
  SAMPLE: '样品仓',
  BULK: '散件仓（总仓）',
  E_COMMERCE: '电商仓（总仓）',
  PART: '配件仓',
  PENDING: '待处理仓（总仓）',
  STOCK_PENDING: '盘点待处理仓'
};

// 标签颜色
export const tagColorMap = {
  // 分配品
  ALLOC_ITEM: 'warning',
  // 暂不发货
  NO_DELIVERY: 'error',
  // 子母件
  ASSEMBLY_ITEM: 'warning',
  // 考核
  EXAMINE: 'warning',
  // 缺货
  OUT_OF_STOCK: 'error',
  //免费
  FREE: 'warning',
  //客需（非直发）
  CUSTOMER_DEMAND_NO_DIRECT: 'warning',
  //客需（直发）
  CUSTOMER_DEMAND_DIRECT: 'warning'
};

export const tagViewMap = {
  ALLOC_ITEM: '分配品',
  NO_DELIVERY: '暂不发货',
  ASSEMBLY_ITEM: '子母件',
  EXAMINE: '考核',
  OUT_OF_STOCK: '缺货',
  FREE: '免费',
  CUSTOMER_DEMAND_NO_DIRECT: '客需（非直发）',
  CUSTOMER_DEMAND_DIRECT: '客需（直发）'
};

// 价格类型
export const priceTypeEnumMap = {
  EX_FACTORY_PRICE: '出厂价',
  PRICE: '一口价',
  REAL_PRICE: '实价',
  RETAIL_PRICE: '零售价'
};

// 库存状态
export const inventoryStatusMap = {
  ALL_SATISFIED: '全部满足',
  PARTIALLY_FULFIL: '部分满足',
  NOT_SATISFIED: '不满足'
};
